import { render, staticRenderFns } from "./MultiLoanIncomeInfoPage.vue?vue&type=template&id=7b2eb2a0"
import script from "./MultiLoanIncomeInfoPage.vue?vue&type=script&lang=ts"
export * from "./MultiLoanIncomeInfoPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports